import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="dots-loading"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 32 24"
    {...props}
  >
    <style>
      {
        "@keyframes spinner_MGfb{93.75%,to{opacity:.2}}.spinner_S1WN{animation:spinner_MGfb .8s linear infinite;animation-delay:-.8s}"
      }
    </style>
    <circle cx={4} cy={12} r={3} className="spinner_S1WN" />
    <circle
      cx={13}
      cy={12}
      r={3}
      className="spinner_S1WN"
      style={{
        animationDelay: "-.65s",
      }}
    />
    <circle
      cx={22}
      cy={12}
      r={3}
      className="spinner_S1WN"
      style={{
        animationDelay: "-.5s",
      }}
    />
  </svg>
);
export default SvgComponent;
